<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">share</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Compartilhar documento</h2>
    <span class="modal-subtitle">{{ data.nomeDocumento }} — o destinatário recebe o link de acesso ao documento.</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="fechar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>E-mail do destinatário</mat-label>
    <input matInput type="email" autocomplete="off" name="vdcEmail" placeholder="nome@empresa.com.br" [(ngModel)]="email">
    <mat-icon matSuffix class="material-symbols-outlined">mail</mat-icon>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Mensagem</mat-label>
    <textarea matInput rows="4" maxlength="2000" name="vdcMensagem" [(ngModel)]="mensagem"></textarea>
  </mat-form-field>

  <button type="button" mat-button class="btn-link vdc-avancado-toggle" [attr.aria-expanded]="mostrarAvancado" (click)="alternarAvancado()">
    {{ mostrarAvancado ? 'Ocultar opções avançadas' : 'Opções avançadas' }}
  </button>

  @if (mostrarAvancado) {
    <div class="vdc-avancado">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Assunto</mat-label>
        <input matInput autocomplete="off" name="vdcAssunto" maxlength="200" [placeholder]="assuntoPadrao"
          [(ngModel)]="assunto">
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Nome do destinatário</mat-label>
        <input matInput autocomplete="off" name="vdcNomeDestinatario" maxlength="150" [(ngModel)]="nomeDestinatario">
      </mat-form-field>
    </div>
  }

  <div class="vdc-link-titulo">Link do documento</div>
  <div class="vdc-link-apoio">
    Quem tiver o link vê a versão vigente do documento, sem precisar de acesso ao sistema. Não há anexo de PDF no envio.
  </div>

  <div class="vdc-link-linha">
    <mat-icon class="material-symbols-outlined vdc-link-icone">link</mat-icon>

    @if (isLinkVigente) {
      <span class="vdc-link-url" [title]="urlLinkPublico">{{ urlLinkPublico }}</span>
    } @else if (isLinkVencido) {
      <span class="vdc-link-url vdc-link-vencido">Link vencido em {{ linkPublicoExpiracao | date: 'dd/MM/yyyy' }}</span>
    } @else {
      <span class="vdc-link-url vdc-link-vazio">O link é gerado ao enviar.</span>
    }

    <mat-form-field appearance="outline" class="vdc-validade" subscriptSizing="dynamic">
      <mat-label>Validade</mat-label>
      <mat-select name="vdcValidade" [(ngModel)]="validadeDias" aria-label="Validade do novo link">
        @for (dias of opcoesValidade; track dias) {
          <mat-option [value]="dias">{{ dias }} dias</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (isLinkVigente) {
      <button mat-icon-button type="button" class="icon-mat-symbols-btn" aria-label="Copiar link" title="Copiar link"
        (click)="copiarLink()">
        <mat-icon class="material-symbols-outlined">content_copy</mat-icon>
      </button>
    }
  </div>

  @if (isLinkVigente) {
    <div class="vdc-vigencia">
      <span class="vdc-vigencia-texto">Vigente até {{ linkPublicoExpiracao | date: 'dd/MM/yyyy' }}</span>
      <button mat-stroked-button type="button" class="btn-secondary" [disabled]="isRevogando || isEnviando"
        (click)="pedirRevogacao()">Revogar link</button>
    </div>
  }

  @if (confirmandoRevogacao) {
    <app-alert-card type="warning" class="vdc-aviso" role="alert">
      <div>Revogar o link? Quem já recebeu deixa de conseguir abrir o documento — não é possível reativar o mesmo link, só gerar um novo.</div>
      <div class="vdc-aviso-acoes">
        <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isRevogando"
          [disabled]="isRevogando" (click)="revogar()">
          Revogar link
          @if (isRevogando) { <mat-spinner diameter="20"></mat-spinner> }
        </button>
        <button mat-button type="button" [disabled]="isRevogando" (click)="cancelarRevogacao()">Manter link</button>
      </div>
    </app-alert-card>
  }

  @if (confirmandoEnvio) {
    <app-alert-card type="warning" class="vdc-aviso" role="alert">
      <div>O link enviado anteriormente deixará de funcionar.</div>
      <div class="vdc-aviso-acoes">
        <button mat-flat-button type="button" class="btn-primary" (click)="enviar()">Gerar novo link e enviar</button>
        <button mat-button type="button" (click)="cancelarConfirmacaoEnvio()">Voltar</button>
      </div>
    </app-alert-card>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" (click)="fechar()">Cancelar</button>
  <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isEnviando"
    [disabled]="isEnviando || isRevogando || confirmandoEnvio" [attr.aria-label]="isEnviando ? 'Enviando' : 'Enviar por e-mail'"
    (click)="enviar()">
    <mat-icon class="material-symbols-outlined">send</mat-icon>
    Enviar por e-mail
    @if (isEnviando) { <mat-spinner diameter="20"></mat-spinner> }
  </button>
</mat-dialog-actions>
